'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';
import { MdLinearScale } from 'react-icons/md';

import type { BaseComponentProps } from '../../../base-component.types';
import { LegendItem } from './layout/LegendItem';

import styles from './Legend.module.scss';

export type LegendProps = BaseComponentProps & {
  labels: Label[];
  icon?: ReactNode;
};

export type Label = {
  value: string;
  color: string;
  icon?: ReactNode;
};

export function Legend({
  style,
  className,
  labels,
  icon,
  testId = 'ui-legend',
}: LegendProps) {
  return (
    <ul
      role="list"
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {labels.map((label, index) => (
        <LegendItem
          key={`${label.value}-${index}`}
          value={label.value}
          color={label.color}
          legendIcon={label.icon ?? icon ?? <MdLinearScale />}
        />
      ))}
    </ul>
  );
}
